var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0136 0.839844L21.5151 7.04533V19.9336L11.0136 25.9005L0.511963 19.2176V7.04533L11.0136 0.839844Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.511963 7.04533L11.0136 13.2508M0.511963 7.04533L11.0136 0.839844L21.5151 7.04533M0.511963 7.04533V19.2176L11.0136 25.9005M11.0136 13.2508L21.5151 7.04533M11.0136 13.2508V25.9005M21.5151 7.04533V19.9336L11.0136 25.9005",
    stroke: "white",
    strokeWidth: 0.612955
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38263 8.07101L3.61187 6.9739L11.0721 2.32752L12.8428 3.42463L5.38263 8.07101Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16816 9.86153L6.39739 8.76442L13.8576 4.11804L15.6284 5.21516L8.16816 9.86153Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0744 11.7063L9.30364 10.6092L16.7639 5.96277L18.5346 7.05988L11.0744 11.7063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCube);
export default __webpack_public_path__ + "static/media/blackCube.cb70c1d9e78e1aa328b6666dca7c5733.svg";
export { ForwardRef as ReactComponent };